import { GroupsRoute } from '@/system-modules/groups/v1/api/GroupsRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { IGroup } from '@/contracts/system-modules/groups/IGroup'
import { EnumGroupRole } from '@/contracts/system-modules/groups/enum/EnumGroupRole'
import { RenameGroupParams } from '@/system-modules/groups/v1/api/v1/groups/RenameGroup/Dto/RenameGroupParams'

export class RenameGroupRoute extends GroupsRoute<RenameGroupParams, IGroup> {
  constructor(private readonly groupUuid: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.PUT
  }

  url(): string {
    return '/api/system/v1/groups/' + this.groupUuid
  }

  /** Без сервера новое название принимается */
  offline(params: RenameGroupParams): Promise<ApiResponse<IGroup>> {
    return Promise.resolve(new ApiResponse({
      success: true,
      data: { uuid: this.groupUuid, ownerUuid: '', title: params.title, role: EnumGroupRole.OWNER },
    }))
  }
}
